import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import { Lazyload, Toast } from 'vant';

import App from './App';
import { router } from '@/routes';
import store from '@/store';
import '@/utils/request';
import '@/assets/styles/common.less';
// pwa
import './registerServiceWorker';

import * as filters from './filters';
import * as tools from './utils/tools';
import * as storage from './utils/storage';

Vue.use(Lazyload);
Vue.use(VueClipboard);

// 注册全局通过过滤器
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

Vue.prototype.$tools = tools; // 全局工具
Vue.prototype.$storage = storage; // 存储
Vue.prototype.$toast = Toast; // 轻提示
Vue.prototype.$isApp = window.navigator.userAgent.indexOf('Html5Plus') > -1;
store.dispatch('auth/check');

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
